import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {

    pageArray = [];

    @Input() page = 1;
    @Input() totalPage = 1;

    @Output() changePage: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {
        this.getPageArray();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.getPageArray();
    }

    getPageArray() {

        let page = this.page;

        this.pageArray[0] = (page == 1) ? 1 : page - 1;

        if (this.totalPage == page && this.totalPage > 1 && page !== 2) {
            this.pageArray[0] = page - 2;
        }

        if (this.totalPage > 1) {
            this.pageArray[1] = page == 1 ? 2 : page;
            if (this.totalPage == 2) {
                this.pageArray[1] = 2;
            } else if (this.totalPage == page) {
                this.pageArray[1] = page - 1;
            }
        }

        if (this.totalPage > 1 && this.totalPage > page && this.totalPage > 2) {
            this.pageArray[2] = page == 1 ? 3 : page + 1;
        }

    }

    increment() {

        if (this.page < this.totalPage) {
            this.changePage.emit(++this.page);
        }

    }

    decrement() {

        if (this.page > 1) {
            this.changePage.emit(--this.page);
        }

    }

    setPage(page) {

        if (page >= 1 || page <= this.totalPage) {
            this.changePage.emit(page);
        }

    }

}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/pagination/pagination.component.ts